import styled from 'styled-components'
import Drawer from '@mui/material/Drawer'
import IconButton from '@mui/material/IconButton'
import Popover from '@mui/material/Popover'

export const StyledDrawer = styled(Drawer).withConfig({
  shouldForwardProp: (prop) => prop !== 'showPIP',
})`
  display: ${(props) => (props.showPIP ? 'none' : 'block')};
  .MuiPaper-root {
    min-height: 100vh;
    backdrop-filter: blur(18px);
    background-color: rgba(0, 0, 0, 0.5);
  }
`

export const StyledPlayerContainer = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
`

export const StyledPlayerHeader = styled.div`
  position: absolute;
  top: 0px;
  width: 100%;
  background: rgba(0, 0, 0, 0);
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 20px;
`

export const LoaderContainer = styled.div`
  position: absolute;
  top: calc(50% - 25px);
  left: calc(50% - 25px);
`

export const MinimizeButton = styled.img`
  z-index: 10000;
  height: 45px;
  @media (min-width: 1300px) {
    height: 61px;
  }
  &:hover {
    cursor: pointer;
  }
  margin-left: 18px;
`

export const OpenPlaylistButton = styled.img`
  z-index: 10000;
  height: 45px;
  @media (min-width: 1300px) {
    height: 61px;
  }
  &:hover {
    cursor: pointer;
  }
  margin-left: auto;
`

export const StyledHeaderButton = styled.img`
  z-index: 10000;
  height: 45px;
  @media (min-width: 1300px) {
    height: 61px;
  }
  &:hover {
    cursor: pointer;
  }
`

export const PlayListContainerPopup = styled(Popover)`
  .MuiPaper-root {
    height: 400px;
    background: rgba(0, 0, 0, 0.5);
    backdrop-filter: blur(8px);
  }
`

export const CoursePlayListHeader = styled.div`
  width: 100% !important;
  padding-top: 18px;
  display: flex;
  justify-content: center;
  width: 94px;
  height: 46px;
  font-family: 'Outfit';
  font-style: normal;
  font-weight: 400;
  font-size: 38px;
  line-height: 46px;
  /* identical to box height */

  letter-spacing: 0.08em;

  color: #ffffff;
`

export const StyledPlayer = styled.div`
  height: 100vh;
`

export const StyledDetailsTitle = styled.div`
  color: #ffffff;
  font-family: 'heroregular';
  font-style: normal;
  font-weight: 400;
  font-size: 46px;
  line-height: 55px;
  letter-spacing: 0.06em;
  padding-top: 57px;
`

export const StyledDetailsDescription = styled.div`
  color: #f9f9f9;
  font-family: 'heroregular';
  font-style: normal;
  font-weight: 400;
  font-size: 26px;
  line-height: 27px;
  width: 50%;
`

export const StyledDetailedContent = styled.div`
  padding-top: 30px;
  display: flex;
`

export const StyledTeacherImage = styled.div`
  height: 110px;
  width: 110px;
  background-image: url(${(props) => props.imgURL});
  border-radius: 50%;
  background-size: cover;
`

export const StyledTeacherDetails = styled.div`
  display: flex;
  flex-direction: row;
  width: 50%;
  justify-content: right;
  align-items: center;
`

export const StyledTeacherName = styled.div`
  font-family: 'heroregular';
  font-style: normal;
  font-weight: 600;
  font-size: 25px;
  line-height: 16px;
  color: #ffffff;
  padding-left: 15px;
`

// new additions : for music player

export const PlayerBackgroundContainer = styled.div`
  width: 100%;
  min-height: 100vh;
  position: absolute;
  top: 0;
  left: 0;
  background: url(${(props) => props?.background});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
`

export const PlayerBackgroundOverlay = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background: #00000080;
`

export const PlayerDetailsRow = styled.div`
  display: flex;
  width: 100%;
  gap: 20px;
  position: absolute;
  bottom: ${(props) => (props?.noSlider ? '100px' : '200px')};
`

export const PlayerSessionImage = styled.img`
  width: 100px;
  height: 100px;
  border-radius: 5px;
  margin-left: 7.5%;
  object-position: center;
  object-fit: cover;
  @media (min-width: 768px) {
    width: 150px;
    height: 150px;
    border-radius: 10px;
    margin-left: 5%;
  }
  @media (min-width: 1300px) {
    width: 200px;
    height: 200px;
    border-radius: 15px;
    margin-left: 2.5%;
  }
`

export const PlayerDetailTextItems = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  justify-content: end;
`

export const PlayerDetailText = styled.div`
  font-size: ${(props) => (props?.main ? '25px' : '20px')};
  font-family: Outfit;
  font-weight: 600;
  color: ${(props) => (props?.main ? '#FFF' : '#999999')};
  @media (min-width: 768px) {
    font-size: ${(props) => (props?.main ? '30px' : '25px')};
  }
  @media (min-width: 1300px) {
    font-size: ${(props) => (props?.main ? '35px' : '30px')};
  }
`
